import {
  ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE,
  ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST,
  ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS,
  FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE,
  FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST,
  FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { CardtronicsCustomers } from "./types";

export const fetchCardtronicsCustomerListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  },
) => ({
  type: FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST,
  url,
  payload,
});

export const fetchCardtronicsCustomerListSuccess = (
  cardtronicsCustomerList: CardtronicsCustomers[],
  totalCount: number,
) => ({
  type: FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS,
  payload: { cardtronicsCustomerList, totalCount },
});

export const fetchCardtronicsCustomerListFailure = (error: string) => ({
  type: FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE,
  payload: error,
});

export const addUpdateCardtronicsCustomerRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCardtronicsCustomerSuccess = (
  successMessage: string,
) => ({
  type: ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCardtronicsCustomerFailure = (error: string) => ({
  type: ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE,
  payload: error,
});
